import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { Form, Spinner } from 'react-bootstrap'
import { message } from 'antd'

import { updateWarehouse } from '../services'
import { handleError } from '../../../helpers'

export default function EditWarehouseModal({ visible, onClose, warehouse, reload }) {
	const [loading, setLoading] = useState(false)
	const { handleSubmit, register, formState: { errors } } = useForm({
		defaultValues: {
			name: warehouse.name,
            address: warehouse.address,
            docks_count: warehouse.docks_count,
		}
	})

	const onSubmit = values => {
		setLoading(true)
		updateWarehouse(warehouse.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Bodega</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<Form.Group className='form-group'>
							<Form.Label>Código <span className='text-danger'>*</span></Form.Label>
							<Form.Control  value={warehouse.sku} disabled />
						</Form.Group>
						<Form.Group className='form-group'>
							<Form.Label>Nombre de Bodega <span className='text-primary'>*</span></Form.Label>
							<Form.Control
								{...register('name', { required:true })}
								placeholder='Escriba aquí...'
							/>
							{ errors.name && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
						</Form.Group>
						<Form.Group className='form-group'>
							<Form.Label>Dirección <span className='text-danger'>*</span></Form.Label>
							<Form.Control 
								{...register('address', { required:true })}
								placeholder='Escriba aquí...'
							/>
							{ errors.address && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
						</Form.Group>
						<Button color="primary" type="submit" disabled={loading}>
							{ loading && <Spinner animation='border' size="sm" className='mr-5' /> }
							Actualizar Bodega
						</Button>						
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}